import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-facebook-ads-details',
  templateUrl: './help-facebook-ads-details.component.html'
})
export class HelpFacebookAdsDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
